<template>
    <div id="login-page">
        <header>
            <div>
                <h1>
                    <a href="/">BARギコ ノア</a>
                </h1>
            </div>
        </header>
        

        <form id="login-form" v-on:submit.prevent>
            <input v-if="passwordInputVisible" type="text" v-model="password" name="room_password" autocomplete="off" data-lpignore="true" data-1p-ignore="true" data-bwignore="true" />
            <div class="noah-area-summary">
                ◆ 人数- {{ currentPopulation }}　配信者- {{ streamingUsers.length }}
            </div>

            <div id="area-selection">
                <label v-for="(siteArea, index) in props.siteAreas" v-show="!siteArea.unlisted"
                    :for="siteArea.id + '-selection'">
                    <input type="radio" :id="siteArea.id + '-selection'" :value="siteArea.id" v-model="areaId"
                        v-on:click="handleLanguageChange(siteArea)" :disabled="isLoggingIn" />
                    {{ siteArea.name }} [{{
                        $t("ui.login_user_count")! +
                        props.siteAreasInfo[siteArea.id].userCount
                    }}
                    {{
                        $t("ui.login_streamer_count")! +
                        props.siteAreasInfo[siteArea.id].streamCount
                    }}]</label>
            </div>
            <div id="login-streaming-users">
                <div id="login-streaming-users-box">
                    <div v-if="isLoadingStreamingUsers" class="login-streaming-users-message">
                        配信状況を確認中
                    </div>
                    <div v-else-if="streamingUsers.length > 0">
                        <ul id="login-streaming-users-list">
                            <li v-for="streamer in streamingUsers" :key="streamer.userId">
                                {{ streamer.userName }}
                            </li>
                        </ul>
                        <div class="login-streaming-users-message">
                            が配信中！
                        </div>
                    </div>
                    <div v-else class="login-streaming-users-message">
                        現在、配信中のユーザーは居ません...
                    </div>
                    <div v-if="streamingUsersError" class="login-streaming-users-error">
                        {{ streamingUsersError }}
                    </div>
                </div>
            </div>

<div id="username-selection">
                <label>名前：</label>
                <input id="username-textbox" name="display_name" autocomplete="nickname" autocapitalize="off" spellcheck="false" data-lpignore="true" data-1p-ignore="true" data-bwignore="true" type="text" v-model="username"
                    v-bind:placeholder="$t('default_user_name')!" :disabled="isLoggingIn"  v-on:keydown.enter.prevent="handleLoginClick" />
                <label class="anonymous-login-toggle">
                    <input type="checkbox" v-model="loginAsAnonymous" :disabled="isLoggingIn" />
                    名無しさん
                </label>
                <span v-if="!isValidUsername" class="error">{{ $t("ui.error_invalid_username") }}</span>
            </div>
            <div id="character-selection">
                <label v-for="character in allCharacters" :for="character.characterName + '-selection'"
                    v-show="NOAH_VISIBLE_CHARACTER_IDS.has(character.characterName)" v-bind:class="{
                        'character-selected': character.characterName == characterId,
                    }">
                    <template v-if="character.isHidden && !NOAH_VISIBLE_CHARACTER_IDS.has(character.characterName)">
                        This is a secret, please don't tell anyone.
                        これは秘密です、誰にも言わないでください
                    
        <pre class="noah-aa-easter-egg">.　　. ＼：／
　     ・･･･☆･･･・
. ⋀,,⋀ ∩.＼
(*・ω・)/
.(つ　 ﾉ
.しーＪ</pre>

</template>
                    <input type="radio" :id="character.characterName + '-selection'" :disabled="isLoggingIn"
                        :value="character.characterName" v-model="characterId" />
                    <img :style="{
                        top: character.portrait.top! * 100 + '%',
                        left: character.portrait.left! * 100 + '%',
                        width: character.portrait.scale! * 100 + '%',
                    }" :src="'characters/' +
                character.characterName +
                '/front-standing.' +
                character.format +
                '?v=20261019b'
                " />
                </label>
            </div>
            
<label>
                        スポーン 
                        <select id="login-spawn-room" v-model="selectedInitialRoomId" v-on:change="handleInitialRoomChange" :disabled="isLoadingLoginRooms || loginRoomOptions.length === 0">
                            <option v-if="loginRoomOptions.length === 0" :value="selectedInitialRoomId">
                                {{ selectedInitialRoomId || "admin_st" }}
                            </option>
                            <option v-for="room in loginRoomOptions" :key="room.id" :value="room.id">
                                {{ $t("room." + room.id) == "room." + room.id ? room.id : $t("room." + room.id) }}
                            </option>
                        </select>
                    </label>


                <div class="login-preset-summary">
                    {{ selectedLoginPresetSummary }}
                </div>

                <div v-if="loginPresetStatus" class="login-preset-status">
                    {{ loginPresetStatus }}
                </div>


<br />
<div id="auth-login-box" class="noah-auth-box">
            <div class="auth-box-title">住民登録（ チャット／配信用 ）</div>
              <p>
                  
              </p>
              <p>
              </p>


            <div v-if="isAuthLoggedIn" class="auth-status auth-status-ok">
                住民登録 ◯
            </div>

            <div v-if="isAuthLoggedIn" class="auth-permission-summary">
                <div>チャット：{{ authCanSpeak ? "可能" : "不可" }}</div>
                <div>配信：{{ authCanStream ? "可能" : "不可" }}</div>
                <div v-if="!authCanStream" class="auth-permission-note">
                </div>
            </div>
            <div v-else class="auth-status auth-status-ng">
                未登録
            </div>

            <div id="auth-login-fields">
                <input type="email" v-model="authEmail" name="email" autocomplete="username" placeholder="メールアドレス" :disabled="isAuthLoggingIn" />
                <input type="password" v-model="authPassword" name="password" autocomplete="current-password" placeholder="当サイト用パスワード" :disabled="isAuthLoggingIn" />
                <button type="button" v-on:click.prevent="handleAuthLoginClick" :disabled="isAuthLoggingIn">
                    ログイン / 登録
                </button>
                <button type="button" v-on:click.prevent="handleAuthRegisterClick" :disabled="isAuthLoggingIn">
                    新規登録
                </button>
                <button type="button" v-if="isAuthLoggedIn" v-on:click.prevent="handleAuthLogoutClick" :disabled="isAuthLoggingIn">
                    登録解除
                </button>
                              <button type="button" v-on:click.prevent="handlePasswordResetRequestClick" :disabled="isAuthLoggingIn">
                      パスワード忘れた...
                  </button>
</div>

              <div class="auth-extra-notes">
                  <p class="auth-note">
                      
                  </p>
                  <p class="auth-note">
                      <small class="noah-small-note">平文保存せず、ハッシュ値のみ保存</small>
                      <br />
                  </p>
                  <p class="auth-note">
                      
                  </p>
              </div>


            <div v-if="authVerificationUrl" class="auth-verification">
                <p>登録完了。下のリンクを開いてログイン / 認証を完了してください</p>
                <a :href="authVerificationUrl" target="_blank" rel="noopener">
                    ログイン / 認証リンクを開く
                </a>
            </div>


              <div v-if="authPasswordResetUrl" class="auth-verification">
                  <p>パスワード再設定リンクを開いてください</p>
                  <a :href="authPasswordResetUrl" target="_blank" rel="noopener">
                      パスワード再設定リンクを開く
                  </a>
              </div>

              <div v-if="passwordResetToken" class="auth-verification">
                  <p>新しいパスワードを入力してください</p>
                  <input type="password" v-model="passwordResetNewPassword" name="new_password" autocomplete="new-password" placeholder="新しい当サイト用パスワード" :disabled="isAuthLoggingIn" />
                  <button type="button" v-on:click.prevent="handlePasswordResetSubmitClick" :disabled="isAuthLoggingIn">
                      パスワードを再設定
                  </button>
              </div>

            <div v-if="authMessage" class="auth-message">
                {{ authMessage }}
            </div>
        </div>
            <div class="noah-login-button-row">
                <button type="button" id="login-button" v-on:click.prevent="handleLoginClick" :disabled="isLoggingIn || !isValidLoginUsername">
                    入口
                </button>
            </div>

            <div class="noah-manual-link">
                <br />
                <br />
                <a href="https://piku.page/@noah"
                   rel="noopener noreferrer">ギコノア説明書</a>
            </div>

        </form>
        <div id="login-footer" translate="no" class="notranslate">
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { characters } from "../character";
import { SiteArea, SiteAreasInfo } from "../types";

const emit = defineEmits<{
    login: [
        username: string,
        password: string,
        areaId: string,
        characterId: string,
        initialRoomId: string
    ];
    setlanguage: [siteArea: SiteArea];
}>();

const props = defineProps({
    areaId: { type: String, required: true },
    passwordInputVisible: { type: Boolean, required: true },
    isLoggingIn: { type: Boolean, required: true },
    siteAreasInfo: { type: Object as () => SiteAreasInfo, required: true },
    siteAreas: { type: Array as () => SiteArea[], required: true },
});

const allCharacters = Object.values(characters);
// NOAH_AVATAR_VISIBILITY
const NOAH_VISIBLE_CHARACTER_IDS = new Set<string>([
    "shobon_chiikawa",
    "shobon_hachiware",
    "shobon_usagi",
    "waddledee",
    "giko",
    "naito",
    "shii",
    "shobon",
    "nida",
    "aramaki",
]);

const currentSiteArea = computed(() => {
    return props.siteAreas.find(siteArea => siteArea.id === areaId.value);
});


const currentAreaInfo = computed(() => {
    const propsAny = props as any;
    const areaIdValue = areaId.value;

    return propsAny.siteAreasInfo?.[areaIdValue]
        ?? propsAny.areasInfo?.[areaIdValue]
        ?? propsAny.siteAreaInfo?.[areaIdValue]
        ?? currentSiteArea.value
        ?? {};
});

const currentPopulation = computed(() => {
    const info = currentAreaInfo.value as any;

    return info.population
        ?? info.userCount
        ?? info.usersCount
        ?? info.numUsers
        ?? info.user_count
        ?? 0;
});

const currentStreamerCount = computed(() => {
    const info = currentAreaInfo.value as any;
    const siteArea = currentSiteArea.value as any;

    const candidates = [
        info.streamersCount,
        info.streamerCount,
        info.streamCount,
        info.streamingCount,
        info.broadcastCount,
        info.broadcasterCount,
        info.numStreamers,
        info.numStreaming,
        info.numBroadcasters,
        info.streamers_count,
        info.streamer_count,
        info.stream_count,
        info.streaming_count,
        info.broadcast_count,
        siteArea?.streamersCount,
        siteArea?.streamerCount,
        siteArea?.streamCount,
        siteArea?.streamingCount,
        siteArea?.broadcastCount,
        siteArea?.broadcasterCount,
        siteArea?.numStreamers,
        siteArea?.numStreaming,
        siteArea?.numBroadcasters,
        siteArea?.streamers_count,
        siteArea?.streamer_count,
        siteArea?.stream_count,
        siteArea?.streaming_count,
        siteArea?.broadcast_count,
    ];

    for (const value of candidates) {
        if (typeof value === "number") {
            return value;
        }
        if (typeof value === "string" && value !== "" && !Number.isNaN(Number(value))) {
            return Number(value);
        }
    }

    const arrayCandidates = [
        info.streamers,
        info.streamingUsers,
        info.broadcasters,
        info.broadcastingUsers,
        info.streams,
        siteArea?.streamers,
        siteArea?.streamingUsers,
        siteArea?.broadcasters,
        siteArea?.broadcastingUsers,
        siteArea?.streams,
    ];

    for (const value of arrayCandidates) {
        if (Array.isArray(value)) {
            return value.length;
        }
    }

    return 0;
});



const username = ref(localStorage.getItem("username") || "");
const loginAsAnonymous = ref(false);
const password = ref("");
const areaId = ref(props.areaId);
const characterId = ref(localStorage.getItem("characterId") || "giko");

const authEmail = ref(localStorage.getItem("authEmail") || "");
const authPassword = ref("");
const authMessage = ref("");
const authVerificationUrl = ref("");
const authPasswordResetUrl = ref("");
const passwordResetToken = ref("");
const passwordResetNewPassword = ref("");

const isAuthLoggingIn = ref(false);
const isAuthLoggedIn = ref(false);
const authCanSpeak = ref(false);
const authCanStream = ref(false);

const LOGIN_ROOM_STORAGE_KEY = "initialRoomId";

function getInitialLoginRoomId(): string {
    try {
        const urlSearchParams = new URLSearchParams(window.location.search);
        return urlSearchParams.get("roomid") || localStorage.getItem(LOGIN_ROOM_STORAGE_KEY) || "admin_st";
    }
    catch {
        return localStorage.getItem(LOGIN_ROOM_STORAGE_KEY) || "admin_st";
    }
}

type LoginRoomOption = {
    id: string,
};

const selectedInitialRoomId = ref(getInitialLoginRoomId());
const loginRoomOptions = ref<LoginRoomOption[]>([]);
const isLoadingLoginRooms = ref(false);
const loginRoomOptionsError = ref("");

const fetchLoginRooms = async (
    targetAreaId: string = areaId.value,
    preferredRoomId: string = selectedInitialRoomId.value
) => {
    isLoadingLoginRooms.value = true;
    loginRoomOptionsError.value = "";

    try {
        const response = await fetch("/api/login-rooms?areaId=" + encodeURIComponent(targetAreaId), {
            credentials: "same-origin",
        });

        const data = await response.json();

        if (!response.ok || !data.ok || !Array.isArray(data.rooms)) {
            throw new Error("invalid login rooms response");
        }

        loginRoomOptions.value = data.rooms.filter((room: Partial<LoginRoomOption>) =>
            typeof room.id === "string" && room.id.trim()
        ) as LoginRoomOption[];

        // NOAH_HIDE_LEGACY_ROOMS_LOGIN_V2: hide only from the login room choices
        const noahHiddenLoginRoomIds = new Set(["jinja_st", "takadai", "bar_st", "bar_giko_square", "monachat", "yatai", "radio", "radio_gakuya", "radio_backstage"]);
        loginRoomOptions.value = loginRoomOptions.value.filter(
            room => !noahHiddenLoginRoomIds.has(room.id)
        );

        const preferredExists = loginRoomOptions.value.some(room => room.id === preferredRoomId);

        if (preferredExists) {
            selectedInitialRoomId.value = preferredRoomId;
        }
        else if (loginRoomOptions.value.some(room => room.id === "admin_st")) {
            selectedInitialRoomId.value = "admin_st";
        }
        else if (loginRoomOptions.value.length > 0) {
            selectedInitialRoomId.value = loginRoomOptions.value[0].id;
        }
    }
    catch {
        loginRoomOptions.value = [];
        loginRoomOptionsError.value = "スポーンマップ一覧を取得できませんでした";
    }
    finally {
        isLoadingLoginRooms.value = false;
    }
};

const handleInitialRoomChange = () => {
    localStorage.setItem(
        LOGIN_ROOM_STORAGE_KEY,
        selectedInitialRoomId.value || "admin_st"
    );
};


type StreamingUser = {
    userId: string,
    userName: string,
    areaId: string,
    roomId: string,
    listenerCount: number,
    withVideo: boolean,
    withSound: boolean,
};

const STREAMING_USERS_VISIBLE_STORAGE_KEY = "noahStreamingUsersVisible";

const showStreamingUsers = ref(true);
const streamingUsers = ref<StreamingUser[]>([]);
const isLoadingStreamingUsers = ref(false);
const streamingUsersError = ref("");

let streamingUsersTimer: ReturnType<typeof window.setInterval> | null = null;

const fetchStreamingUsers = async () => {
    isLoadingStreamingUsers.value = true;
    streamingUsersError.value = "";

    try {
        const response = await fetch("/api/streaming-users", {
            credentials: "same-origin",
        });

        const data = await response.json();

        if (!response.ok || !data.ok || !Array.isArray(data.streamers)) {
            throw new Error("invalid streaming users response");
        }

        streamingUsers.value = data.streamers.filter((streamer: Partial<StreamingUser>) =>
            typeof streamer.userId === "string" &&
            typeof streamer.userName === "string"
        ) as StreamingUser[];
    }
    catch {
        streamingUsers.value = [];
        streamingUsersError.value = "配信状況を取得できませんでした";
    }
    finally {
        isLoadingStreamingUsers.value = false;
    }
};

const handleShowStreamingUsersChange = () => {
    localStorage.setItem(STREAMING_USERS_VISIBLE_STORAGE_KEY, showStreamingUsers.value ? "true" : "false");

    if (showStreamingUsers.value) {
        void fetchStreamingUsers();
    }
    else {
        streamingUsers.value = [];
        streamingUsersError.value = "";
    }
};

onMounted(() => {
    void fetchStreamingUsers();

    streamingUsersTimer = window.setInterval(() => {
        void fetchStreamingUsers();
    }, 30000);
});

onBeforeUnmount(() => {
    if (streamingUsersTimer !== null) {
        window.clearInterval(streamingUsersTimer);
        streamingUsersTimer = null;
    }
});


const isValidUsername = computed(() => {
    // Allow usernames up to 20 characters, excluding the tripcode
    return /^.{0,20}(#.*){0,1}$/.test(username.value);
});

const effectiveLoginUsername = computed(() => {
    return loginAsAnonymous.value ? "名無しさん" : username.value;
});

const isValidLoginUsername = computed(() => {
    return loginAsAnonymous.value || isValidUsername.value;
});

const updateAuthState = async () => {
    try {
        const response = await fetch("/api/auth/me", {
            credentials: "include",
        });

        const data = await response.json();

        isAuthLoggedIn.value = !!data.isLoggedIn;
        authCanSpeak.value = !!data.account?.canSpeak;
        authCanStream.value = !!data.account?.canStream;

        if (isAuthLoggedIn.value && authCanSpeak.value) {
            authMessage.value = "ログイン / 登録済み";
        }
        else if (isAuthLoggedIn.value) {
            authMessage.value = "ログイン / 登録済みですが、現在は発言権限がありません。配信は登録から10分後、可能になります";
        }
        else {
            authMessage.value = "";
        }
    }
    catch {
        isAuthLoggedIn.value = false;
        authCanSpeak.value = false;
        authCanStream.value = false;
        authMessage.value = "ログイン / 登録状態を確認できませんでした";
    }
};

const handleAuthRegisterClick = async () => {
    if (!authEmail.value || !authPassword.value) {
        authMessage.value = "メールアドレスと当サイト用パスワードを入力してください";
        return;
    }

    if (authPassword.value.length < 8) {
        authMessage.value = "パスワードは8文字以上にしてください";
        return;
    }

    isAuthLoggingIn.value = true;
    authMessage.value = "";
    authVerificationUrl.value = "";
      authPasswordResetUrl.value = "";

    try {
        const response = await fetch("/api/auth/register", {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            credentials: "include",
            body: JSON.stringify({
                email: authEmail.value,
                password: authPassword.value,
            }),
        });

        const data = await response.json();

        if (!response.ok || !data.ok) {
            if (data.error === "too_many_register_attempts") {
                authMessage.value = "新規登録の試行回数が多すぎます。暫く時間をおいてから再度お試しください";
            }
            else {
                authMessage.value = "新規登録に失敗しました。既に登録済みのメールアドレスかもしれません";
            }
            return;
        }

        localStorage.setItem("authEmail", authEmail.value);
        authVerificationUrl.value = data.verificationUrl || "";
        if (data.mailSent) {
            authMessage.value = "新規登録に成功しました。認証メールを送信しました。メール内のリンクを開いてください。";
        }
        else if (authVerificationUrl.value) {
            authMessage.value = "新規登録に成功しました。ログイン / 認証リンクを開いてください。";
        }
        else {
            authMessage.value = "新規登録に成功しました。登録手続きを続けてください。";
        }
    }
    catch {
        authMessage.value = "新規登録に失敗しました";
    }
    finally {
        isAuthLoggingIn.value = false;
    }
};

const handleAuthLoginClick = async () => {
    if (!authEmail.value || !authPassword.value) {
        authMessage.value = "メールアドレスと当サイト用パスワードを入力してください";
        return;
    }

    isAuthLoggingIn.value = true;
    authMessage.value = "";

    try {
        const response = await fetch("/api/auth/login", {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            credentials: "include",
            body: JSON.stringify({
                email: authEmail.value,
                password: authPassword.value,
            }),
        });

        const data = await response.json();

        if (!response.ok || !data.ok) {
            authMessage.value = "メールアドレスまたはパスワードが正しくありません";
            return;
        }

        localStorage.setItem("authEmail", authEmail.value);
        authPassword.value = "";
        authMessage.value = "ログイン / 登録に成功しました。このまま入室してください";

        await updateAuthState();
    }
    catch {
        authMessage.value = "ログイン / 登録に失敗しました";
    }
    finally {
        isAuthLoggingIn.value = false;
    }
};


const handlePasswordResetRequestClick = async () => {
    if (!authEmail.value || !authEmail.value.includes("@")) {
        authMessage.value = "パスワード再設定にはメールアドレスを入力してください";
        return;
    }

    isAuthLoggingIn.value = true;
    authMessage.value = "";
    authPasswordResetUrl.value = "";

    try {
        const response = await fetch("/api/auth/request-password-reset", {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            credentials: "include",
            body: JSON.stringify({
                email: authEmail.value,
            }),
        });

        const data = await response.json();

        if (!response.ok || !data.ok) {
            if (data.error === "too_many_reset_attempts") {
                authMessage.value = "パスワード再設定の試行回数が多すぎます。暫く時間をおいてから再度お試しください";
            }
            else {
                authMessage.value = "パスワード再設定の受付に失敗しました";
            }
            return;
        }

        localStorage.setItem("authEmail", authEmail.value);
        authPasswordResetUrl.value = data.resetUrl || "";
        authMessage.value = "登録済みの場合、パスワード再設定メールを送信しました。メール内のリンクを開いてください";
    }
    catch {
        authMessage.value = "パスワード再設定の受付に失敗しました";
    }
    finally {
        isAuthLoggingIn.value = false;
    }
};

const handlePasswordResetSubmitClick = async () => {
    if (!passwordResetToken.value) {
        authMessage.value = "パスワード再設定トークンがありません";
        return;
    }

    if (passwordResetNewPassword.value.length < 8) {
        authMessage.value = "新しいパスワードは8文字以上にしてください";
        return;
    }

    isAuthLoggingIn.value = true;
    authMessage.value = "";

    try {
        const response = await fetch("/api/auth/reset-password", {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            credentials: "include",
            body: JSON.stringify({
                token: passwordResetToken.value,
                password: passwordResetNewPassword.value,
            }),
        });

        const data = await response.json();

        if (!response.ok || !data.ok) {
            if (data.error === "invalid_or_expired_token") {
                authMessage.value = "パスワード再設定リンクが無効、又は有効期限切れです";
            }
            else if (data.error === "invalid_password") {
                authMessage.value = "新しいパスワードは8文字以上にしてください";
            }
            else {
                authMessage.value = "パスワード再設定に失敗しました";
            }
            return;
        }

        passwordResetToken.value = "";
        passwordResetNewPassword.value = "";
        authPasswordResetUrl.value = "";
        authPassword.value = "";
        isAuthLoggedIn.value = false;
        authCanSpeak.value = false;
        authCanStream.value = false;
        authMessage.value = "パスワードを再設定しました。新しいパスワードでログインしてください";

        const url = new URL(window.location.href);
        url.searchParams.delete("passwordResetToken");
        window.history.replaceState({}, document.title, url.toString());
    }
    catch {
        authMessage.value = "パスワード再設定に失敗しました";
    }
    finally {
        isAuthLoggingIn.value = false;
    }
};


const handleAuthLogoutClick = async () => {
    isAuthLoggingIn.value = true;

    try {
        await fetch("/api/auth/logout", {
            method: "POST",
            credentials: "include",
        });

        isAuthLoggedIn.value = false;
        authCanSpeak.value = false;
        authCanStream.value = false;
        authPassword.value = "";
        authMessage.value = "ログイン / 登録を解除しました";
    }
    catch {
        authMessage.value = "登録解除に失敗しました";
    }
    finally {
        isAuthLoggingIn.value = false;
    }
};

onMounted(() => {
    const url = new URL(window.location.href);
    const token = url.searchParams.get("passwordResetToken");

    if (token) {
        passwordResetToken.value = token;
        authMessage.value = "パスワード再設定リンクを確認しました。新しいパスワードを入力してください";
    }

    updateAuthState();
    void fetchLoginRooms();
});

const handleLoginClick = () => {
    if (!isValidLoginUsername.value) {
        return;
    }

    const loginRoomId = selectedInitialRoomId.value || "admin_st";
    localStorage.setItem(LOGIN_ROOM_STORAGE_KEY, loginRoomId);

    emit(
        "login",
        effectiveLoginUsername.value,
        password.value,
        areaId.value,
        characterId.value,
        loginRoomId
    );
};

const handleLanguageChange = (siteArea: SiteArea) => {
    areaId.value = siteArea.id;
    emit("setlanguage", siteArea);
    void fetchLoginRooms(siteArea.id);
};
</script>

<style scoped>
#auth-login-box {
    width: min(1000px, 96vw);
    max-width: none;
    margin: 14px auto 10px auto;
    padding: 12px;
    border: 1px solid #666;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.08);
    box-sizing: border-box;
}

#auth-login-box h3 {
    margin: 0 0 8px 0;
}

#auth-login-box p {
    margin: 0 0 10px 0;
    line-height: 1.5;
}

#auth-login-fields {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 8px;
}

#auth-login-fields input {
    min-width: 180px;
}

.auth-status {
    margin: 8px 0;
    font-weight: bold;
}

.auth-status-ok {
    color: #4caf50;
}

.auth-status-ng {
    color: #ff9800;
}

.auth-message {
    margin-top: 8px;
}


.auth-extra-notes {
    margin-top: 10px;
}

.auth-note {
    margin: 4px 0;
    font-size: 0.92em;
    line-height: 1.5;
}

.auth-permission-summary {
    width: 100%;
    margin: 8px 0;
    padding: 8px;
    border: 1px solid #777;
    border-radius: 4px;
    line-height: 1.5;
    box-sizing: border-box;
}

.auth-permission-note {
    margin-top: 4px;
    font-size: 0.9em;
}

.auth-verification {
    margin-top: 8px;
    padding: 8px;
    border: 1px solid #888;
    border-radius: 4px;
}

.auth-verification p {
    margin: 0 0 6px 0;
}

#login-preset-box {
    width: min(1000px, 96vw);
    max-width: none;
    margin: 12px auto 10px auto;
    padding: 10px 12px;
    border: 1px solid #666;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.08);
    box-sizing: border-box;
}

#login-preset-box h3 {
    margin: 0 0 8px 0;
}

#login-preset-controls {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
}

#login-preset-controls label {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

#login-preset-controls input[type="text"] {
    min-width: 160px;
}

#login-preset-controls button {
    white-space: nowrap;
}

.login-preset-summary {
    margin-top: 8px;
    line-height: 1.5;
}

.login-preset-note {
    margin-top: 4px;
    font-size: 0.92em;
    opacity: 0.85;
    line-height: 1.5;
}

.login-preset-status {
    margin-top: 6px;
    font-weight: bold;
    color: #4caf50;
}


#login-preset-header {
    display: flex;
    align-items: center;
}

#login-preset-visibility-toggle {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    user-select: none;
}

#login-preset-body {
    margin-top: 10px;
}


#login-spawn-room {
    max-width: 260px;
}



/* Noah: Loginボタンの色を他の認証ボタンと同じ標準グレー系に寄せる(修正したぞ)) */
#login-button.noah-main-login-button {
    background: buttonface !important;
    background-image: none !important;
    color: buttontext !important;
    border: 1px solid #767676 !important;
    box-shadow: none !important;
    text-shadow: none !important;
}

#login-button.noah-main-login-button:hover {
    background: #767676 !important;
    background-image: none !important;
}

#login-button.noah-main-login-button:active {
    background: #767676 !important;
    background-image: none !important;
}

</style>

<style>
/* Noah login screen polish */
.noah-main-login-button {
    display: block;
    width: min(360px, 92vw);
    margin: 14px auto 10px auto;
    padding: 10px 18px;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.3;
    border: 2px solid #111;
    border-radius: 6px;
    background: linear-gradient(#fff7c8, #f0b83f);
    color: #0000EE;
    box-shadow: 0 3px 0 #7a4c00, 0 4px 8px rgba(0, 0, 0, 0.25);
    cursor: pointer;
}

.noah-main-login-button:hover {
    filter: brightness(1.05);
}

.noah-main-login-button:active {
    transform: translateY(2px);
    box-shadow: 0 1px 0 #7a4c00, 0 2px 4px rgba(0, 0, 0, 0.25);
}

.noah-main-login-button:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    filter: grayscale(0.4);
}

/* スマホログイン画面のタイトル被り対策 */
@media (max-width: 520px) {
    .login-page {
        padding-top: 18px;
    }

    .login-page h1,
    .login-page h2,
    .login-page .title,
    .login-page .site-title {
        display: block;
        max-width: 94vw;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 12px;
        line-height: 1.25;
        word-break: keep-all;
        overflow-wrap: anywhere;
        text-align: center;
    }

    .noah-main-login-button {
        width: 92vw;
        max-width: 360px;
        min-height: 44px;
        font-size: 17px;
        margin-top: 16px;
        margin-bottom: 14px;
    }
}
</style>


<style>
/* Noah final main login button */
#login-button.noah-main-login-button,
.noah-main-login-button {
    display: block !important;
    width: min(360px, 92vw) !important;
    min-height: 48px !important;
    margin: 16px auto 14px auto !important;
    padding: 10px 18px !important;
    font-size: 18px !important;
    font-weight: bold !important;
    line-height: 1.3 !important;
    color: #2b0052 !important;
    border: 2px solid #5a3600 !important;
    border-radius: 8px !important;
    background: linear-gradient(45deg, #B67B03 0%, #DAAF08 45%, #FEE9A0 70%, #DAAF08 85%, #B67B03 100%) !important;
    box-shadow: 0 3px 0 #5a3600, 0 4px 9px rgba(0, 0, 0, 0.3) !important;
    cursor: pointer !important;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.6) !important;
}

#login-button.noah-main-login-button:hover,
.noah-main-login-button:hover {
    filter: brightness(1.07) !important;
}

#login-button.noah-main-login-button:active,
.noah-main-login-button:active {
    transform: translateY(2px) !important;
    box-shadow: 0 1px 0 #5a3600, 0 2px 4px rgba(0, 0, 0, 0.25) !important;
}

#login-button.noah-main-login-button:disabled,
.noah-main-login-button:disabled {
    opacity: 0.6 !important;
    cursor: not-allowed !important;
    filter: grayscale(0.35) !important;
}
</style>


<style>
/* Noah mobile login header final fix */
@media (max-width: 520px) {
    #login-page {
        box-sizing: border-box !important;
        width: 100% !important;
        max-width: 100vw !important;
        overflow-x: hidden !important;
        padding-top: 8px !important;
    }

    #login-page > header {
        position: relative !important;
        display: block !important;
        box-sizing: border-box !important;
        width: 100% !important;
        height: auto !important;
        min-height: 0 !important;
        margin: 0 0 12px 0 !important;
        padding: 8px 8px 6px 8px !important;
        text-align: center !important;
        clear: both !important;
        float: none !important;
        transform: none !important;
        z-index: 1 !important;
    }

    #login-page > header > div {
        position: static !important;
        display: block !important;
        box-sizing: border-box !important;
        width: 100% !important;
        height: auto !important;
        min-height: 0 !important;
        margin: 0 auto !important;
        padding: 0 !important;
        clear: both !important;
        float: none !important;
        transform: none !important;
    }

    #login-page > header h1,
    #login-page > header h2 {
        position: static !important;
        display: block !important;
        box-sizing: border-box !important;
        width: 100% !important;
        max-width: 94vw !important;
        height: auto !important;
        margin-left: auto !important;
        margin-right: auto !important;
        padding: 0 6px !important;
        clear: both !important;
        float: none !important;
        transform: none !important;
        white-space: normal !important;
        word-break: keep-all !important;
        overflow-wrap: anywhere !important;
        text-align: center !important;
        line-height: 1.25 !important;
    }

    #login-page > header h1 {
        margin-top: 0 !important;
        margin-bottom: 4px !important;
        font-size: clamp(20px, 5.4vw, 28px) !important;
    }

    #login-page > header h2 {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        font-size: clamp(12px, 3.6vw, 16px) !important;
    }

    #login-form {
        position: relative !important;
        display: block !important;
        box-sizing: border-box !important;
        width: 100% !important;
        max-width: 100vw !important;
        margin-top: 0 !important;
        padding-top: 6px !important;
        clear: both !important;
        float: none !important;
        transform: none !important;
        z-index: 0 !important;
    }

    #area-selection {
        position: static !important;
        display: flex !important;
        flex-wrap: wrap !important;
        justify-content: center !important;
        align-items: center !important;
        box-sizing: border-box !important;
        width: 100% !important;
        max-width: 94vw !important;
        margin: 0 auto 12px auto !important;
        padding: 6px 4px 2px 4px !important;
        clear: both !important;
        float: none !important;
        transform: none !important;
        text-align: center !important;
        line-height: 1.35 !important;
        gap: 4px 10px !important;
    }

    #area-selection label {
        position: static !important;
        display: inline-flex !important;
        align-items: center !important;
        max-width: 94vw !important;
        margin: 0 4px 6px 4px !important;
        white-space: normal !important;
        line-height: 1.35 !important;
    }

    #area-selection input[type="radio"] {
        flex: 0 0 auto !important;
        margin-right: 4px !important;
    }
}
</style>

<style>
/* Noah mobile login left alignment final */
@media (max-width: 520px) {
    #login-page {
        --noah-login-mobile-margin: clamp(16px, 8vw, 56px);
        box-sizing: border-box !important;
        width: 100vw !important;
        max-width: 100vw !important;
        overflow-x: hidden !important;
    }

    #login-page > header {
        box-sizing: border-box !important;
        width: 100% !important;
        margin: 0 0 18px 0 !important;
        padding: 8px var(--noah-login-mobile-margin) 0 var(--noah-login-mobile-margin) !important;
        text-align: left !important;
    }

    #login-page > header > div {
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        text-align: left !important;
    }

    #login-page > header h1,
    #login-page > header h2 {
        width: 100% !important;
        max-width: none !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
        padding: 0 !important;
        text-align: left !important;
        white-space: normal !important;
        overflow-wrap: anywhere !important;
        word-break: keep-all !important;
    }

    #login-page > header h1 {
        margin-top: 0 !important;
        margin-bottom: 4px !important;
        font-size: clamp(24px, 7vw, 34px) !important;
        line-height: 1.2 !important;
    }

    #login-page > header h2 {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        font-size: clamp(16px, 4.5vw, 22px) !important;
        line-height: 1.25 !important;
    }

    #login-form {
        box-sizing: border-box !important;
        width: 100vw !important;
        max-width: 100vw !important;
        overflow-x: hidden !important;
    }

    #area-selection {
        box-sizing: border-box !important;
        display: block !important;
        width: calc(100vw - (var(--noah-login-mobile-margin) * 2)) !important;
        max-width: none !important;
        margin: 0 0 18px var(--noah-login-mobile-margin) !important;
        padding: 0 !important;
        text-align: left !important;
        line-height: 1.45 !important;
    }

    #area-selection label {
        box-sizing: border-box !important;
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        margin: 0 0 8px 0 !important;
        padding: 0 !important;
        text-align: left !important;
        white-space: normal !important;
        line-height: 1.45 !important;
    }

    #area-selection input[type="radio"] {
        margin-right: 6px !important;
        vertical-align: middle !important;
    }

    #login-button.noah-main-login-button,
    .noah-main-login-button {
        box-sizing: border-box !important;
        display: block !important;
        width: calc(100vw - (var(--noah-login-mobile-margin) * 2)) !important;
        max-width: 360px !important;
        min-width: 0 !important;
        margin-left: var(--noah-login-mobile-margin) !important;
        margin-right: auto !important;
        margin-top: 18px !important;
        margin-bottom: 18px !important;
        padding: 10px 16px !important;
        text-align: center !important;
    }
}
</style>

<style>
/* Noah login button neutral final */
#login-button.noah-main-login-button,
.noah-main-login-button {
    color: #0000EE !important;
    background: linear-gradient(#f8f8f8, #dcdcdc) !important;
    border: 2px solid #777 !important;
    border-radius: 6px !important;
    box-shadow: 0 3px 0 #888, 0 4px 8px rgba(0, 0, 0, 0.22) !important;
    text-shadow: none !important;
}

#login-button.noah-main-login-button:hover,
.noah-main-login-button:hover {
    background: linear-gradient(#ffffff, #e5e5e5) !important;
    filter: none !important;
}

#login-button.noah-main-login-button:active,
.noah-main-login-button:active {
    transform: translateY(2px) !important;
    box-shadow: 0 1px 0 #888, 0 2px 4px rgba(0, 0, 0, 0.22) !important;
}

#login-button.noah-main-login-button:disabled,
.noah-main-login-button:disabled {
    opacity: 0.6 !important;
    background: linear-gradient(#eeeeee, #cccccc) !important;
    color: #555 !important;
    cursor: not-allowed !important;
    filter: grayscale(0.2) !important;
}
</style>


<style>
/* Noah: login page cleanup 20261013 */

/* 「一般(_gen) / International」選択UIは見せない。areaId自体は既存の初期値を使う */
#area-selection {
    display: none !important;
}

/* 未認証メッセージをリンク色に寄せる */
.auth-message {
    color: #0000EE !important;
}

/* DB説明・コピー元説明は小さく控えめに */
.noah-small-note,
#login-footer {
    font-size: 11px !important;
    line-height: 1.35 !important;
    opacity: 0.85;
}

/* Loginボタンは標準ボタンの見た目のまま、横幅だけ控えめにする */
.noah-login-button-row #login-button,
#login-button {
    width: min(210px, 70vw) !important;
}

/* subtitleが残っていた場合の保険 */
#login-page > header h2 {
    display: none !important;
}
</style>


<style>
/* Noah: 未認証メッセージをリンク色に統一 */
.auth-message,
.auth-message *,
#auth-message,
#auth-message *,
.auth-status,
.auth-status *,
.auth-warning,
.auth-warning * {
    color: #0000EE !important;
}
</style>


<style>
/* Noah: area summary */
.noah-area-summary {
    margin: 6px 0 8px 0;
    font-size: 14px;
}
</style>


<style>
/* Noah: 配信中ユーザー欄は常時表示にするため、表示切替チェックは隠す */
#streamers-display-checkbox,
#show-streaming-users,
input[type="checkbox"][id*="stream"],
input[type="checkbox"][id*="broadcast"] {
    display: none !important;
}
</style>


<style>
/* Noah: 配信中欄は切替なしで常時表示 */
.noah-streaming-heading {
    display: block;
    margin: 4px 0 6px 0;
}
</style>


<style>
/* Noah: 入口ボタンを画面左側の通常コンテンツ位置に揃える */
.noah-login-button-row {
    box-sizing: border-box !important;
    width: 100vw !important;
    margin-left: calc(50% - 50vw) !important;
    margin-right: 0 !important;
    margin-top: 16px !important;
    margin-bottom: 14px !important;
    padding-left: 24px !important;
    display: flex !important;
    justify-content: flex-start !important;
}

.noah-login-button-row #login-button {
    width: min(220px, 70vw) !important;
    margin-left: 0 !important;
    margin-right: auto !important;
}

@media (max-width: 520px) {
    .noah-login-button-row {
        padding-left: 16px !important;
    }

    .noah-login-button-row #login-button {
        width: min(220px, calc(100vw - 32px)) !important;
    }
}
</style>





<style>
/* Noah: ユーザー認証欄を左側に揃える最終調整 */
.noah-auth-box {
    box-sizing: border-box !important;
    width: min(850px, calc(100vw - 48px)) !important;
    max-width: none !important;
    margin-left: 24px !important;
    margin-right: auto !important;
}

@media (max-width: 520px) {
    .noah-auth-box {
        width: calc(100vw - 32px) !important;
        margin-left: 16px !important;
        margin-right: auto !important;
    }
}
</style>


<style>
/* Noah: friend easter egg AA */
.noah-aa-easter-egg {
    margin: 24px;
    font-family: monospace;
    font-size: 14px;
    line-height: 1.2;
    white-space: pre;
}
</style>


<style>
/* Noah: 住民登録欄の最終レイアウト調整 */
#auth-login-box.noah-auth-box,
#auth-login-box {
    box-sizing: border-box !important;
    width: min(850px, calc(100vw - 48px)) !important;
    max-width: none !important;

    margin-left: 24px !important;
    margin-right: auto !important;

    padding: 0 !important;

    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    background: transparent !important;
}

@media (max-width: 520px) {
    #auth-login-box.noah-auth-box,
    #auth-login-box {
        width: calc(100vw - 32px) !important;
        margin-left: 16px !important;
        margin-right: auto !important;
    }
}
</style>


<style>
/* Noah: 住民登録と名無しさんチェックの最終調整 */
#auth-login-box.noah-auth-box,
#auth-login-box {
    margin-left: 0 !important;
    margin-right: auto !important;
}

.anonymous-login-toggle {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    margin-left: 2em;
    white-space: nowrap;
    cursor: pointer;
}

.anonymous-login-toggle input[type="checkbox"] {
    margin: 0;
}

@media (max-width: 520px) {
    #auth-login-box.noah-auth-box,
    #auth-login-box {
        margin-left: 0 !important;
        margin-right: auto !important;
    }
}
</style>


<style>
/* Noah: 住民登録見出しを人数表示と同じ14pxに統一 */
#auth-login-box {
    font-size: 14px;
}
</style>


<style>
.auth-box-title {
    font-size: 14px;
}
</style>


<style>
/* Noah: 説明書リンク */
.noah-manual-link {
    margin-left: 24px;
    margin-bottom: 16px;
}

@media (max-width: 520px) {
    .noah-manual-link {
        margin-left: 16px;
    }
}
</style>


<style>
/* Noah: ログイン画面の補助項目を14pxに統一 */

/* 名無しさんチェックボックスの文字 */
.anonymous-login-toggle {
    font-size: 14px !important;
}

/* スポーンの文字 */
label:has(> #login-spawn-room) {
    font-size: 14px !important;
}

/* スポーンのマップ選択欄 */
#login-spawn-room {
    font-size: 14px !important;
}

/* ギコノア説明書リンク */
.noah-manual-link a {
    font-size: 14px !important;
}
</style>


<style>
/* Noah: スポーン選択欄のフォントを周囲と統一 */
#login-spawn-room {
    font-family: inherit !important;
    font-size: 14px !important;
    font-weight: normal !important;
}
</style>

<style>
/* Noah: スマホ版スポーン選択欄の文字サイズ調整 */
@media (max-width: 520px) {
    #login-spawn-room {
        font-size: 12px !important;
        font-family: inherit !important;
        font-weight: normal !important;
    }
}
</style>


<style>
/* Noah: サイト名と人数表示の余白調整 */

/* サイト名を囲むヘッダーの余白を削除 */
#login-page > header {
    height: auto !important;
    min-height: 0 !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

/* ヘッダー内部の高さを調整 */
#login-page > header > div {
    height: auto !important;
    min-height: 0 !important;
}

/* サイト名直下の余白を削除 */
#login-page > header h1 {
    margin-bottom: 0 !important;
}

/* ログインフォーム上部の余白を削除 */
#login-form {
    margin-top: 0 !important;
    padding-top: 0 !important;
}

/* 人数表示は4pxだけ余白を残す */
#login-form .noah-area-summary {
    margin-top: 4px !important;
}
</style>
